import { ModalFullscreen, UIText1, IconButton } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface IModalViewProps {
  isOpened: boolean;
  onClose(): void;
  offersTable: React.ReactElement<any>;
  filters: React.ReactElement<any>;
  offerFromHistory: React.ReactElement<any>;
  title: string;
  moreDetailed: React.ReactNode;
}

export const FullscreenView: React.FC<IModalViewProps> = ({
  isOpened,
  onClose,
  offersTable,
  filters,
  offerFromHistory,
  title,
  moreDetailed,
}) => {
  return (
    <ModalFullscreen open={isOpened} onClose={onClose} theme="white">
      <div className={styles['container']} data-name="OffersHistoryFullscreenView">
        <header className={styles['header']}>
          <UIText1 fontWeight="bold">{title}</UIText1>
          <IconButton icon={<IconActionClose16 />} onClick={onClose} aria-label="Закрыть" />
        </header>
        <div className={styles['main']}>
          <div className={styles['listing']} data-name="ListingSection">
            {filters}
            {moreDetailed}
            <div className={styles['table']}>{offersTable}</div>
          </div>
          <div className={styles['offer']} data-name="OfferSection">
            {offerFromHistory}
          </div>
        </div>
      </div>
    </ModalFullscreen>
  );
};
